import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import MyContext from "MyContext";
import { message } from "antd";
import Selectant from 'react-select';
import { BsArrowLeftShort } from "react-icons/bs"
import PaginationSection from './PaginationSection';
import { useHistory } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import Switch from 'react-switch'; // Import the react-switch component
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table
} from "react-bootstrap";
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table";
import moment from 'moment';


function PendingBankStatus() {
  // const [formData, setFormData] = useState(initialFormData);
  const { endPointUrl, Token } = useContext(MyContext);
  const history = useHistory();
  const [allDetails, setallDetails] = useState([]);
  const [button, setbutton] = useState(false);
  const [name, setName] = useState('')
  const [actualPaid, setActualPaid] = useState('');
  const [PM_ID, setPM_ID] = useState();
  const [bankname, setbankname] = useState('');
  const [accountnum, setaccountnum] = useState('');
  const [accountname, setaccountname] = useState('');
  const [code, setcode] = useState("");
  const [bankcountry, setbankcountry] = useState('');

  // const [cross ,setcross]=useState(true);
  const getpayment = async () => {
    try {
      const { data } = await axios.post(endPointUrl + "/project/getAllMilestone", {
        Token,
      });
      setallDetails(data.data);
      //   console.log(data.data[0].projects[0].paidPayment);

    } catch (error) {
      console.log("get reviews is not working", error);
    }
  };

  useEffect(() => {
    // console.log("Type state:", Type);
    getpayment();
  }, []);
  const closemodal = () => {
    setbutton(false)
  }
  const updateconfirmpayment = async () => {

    try {
      const { data } = await axios.post(endPointUrl + "/project/updatemilestone", {
        Token,
        PM_ID,        
        TransferStatus: "Released",
      });
    } catch (error) {

      message.error("An error occurred.");
    }
  };


  const updatePaymentStatus = async (data) => {
    history.push(`/admin/Payment-Confirmation/${data?.PM_ID}`);
    // setName(`${data.Name} ${data.Last_Name}`)
    // setActualPaid(data.FreelancerActualPaid);
    // setPM_ID(data.PM_ID)
    // setaccountnum(data.Account_Number);
    // setaccountname(data.Account_Name);
    // setbankname(data.Bank_Name)
    // setcode(data.IFSC_CODE)
    // setbankcountry(data.BANK_COUNTRY)
  }





  const data = React.useMemo(() => Array.isArray(allDetails) ? allDetails : [], [allDetails]);
  console.log("alldetails", allDetails)
  const columns = React.useMemo(
    () => [
      {
        Header: "S.No.",
        accessor: (row, index) => index + 1,
      },
      {
        Header: "Freelancer",
        accessor: "Name",

      },

      {
        Header: "ProjectName",
        accessor: "Title",

      },


      {
        Header: "Escrow Amount",
        accessor: "Amount",
        // Cell: ({ row }) => {

        //   const Escrow = row.original.EscrowedAmount;
        //   return Escrow;
        // }
      },

      {
        Header: "Platform Charges",
        accessor: "Platform Charges",
        Cell: ({ row }) => {

          const charges = (row.original.Amount * 10 / 100)
          return charges;
        }
      },
      {
        Header: "Freelancer Actual Paid",
        accessor: "Freelancer Actual Paid",
        Cell: ({ row }) => {
          const status = (row.original.Amount - (row.original.Amount * 10 / 100))

          return status;

        }

      },
      {
        Header: "Transferred Status",
        accessor: "Transferred Status",

        Cell: ({ row }) => {
          const status = row.original.TransferStatus
          return status;

        }
      },



      {
        Header: "Action",
        accessor: "id",

        Cell: ({ row }) => (

          <div>

            <span
              onClick={() => updatePaymentStatus(row.original)}

              style={{ cursor: "pointer", marginRight: "10px" }}
            >

              <Button style={{ fill: "#07b274" }}>Release</Button>
            </span>
          </div>
        ),
      },
    ],
    []
  );


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    gotoPage,
    pageCount,
    state,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 5 },
      autoResetPage: false,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { globalFilter, pageIndex, pageSize } = state;

  // const handleclick = (Id) => {
  //   console.log(Id);
  //   history.push(`/admin/PendingBankStatus/${Id}`);
  // };
  const navigateToFinance = () => {
    history.push("/admin/Finance");
  };
  const handlePrint = () => {
    window.print(); // Open the browser's print dialog
  };
  return (
    <>

      <div className="close profile" onClick={navigateToFinance} >
        <BsArrowLeftShort style={{ fill: "#07b274", margin: "0 0 20px 0" }} />
      </div>

      <div className="download-button" style={{ float: "right" }} onClick={handlePrint} >
        Download PDF
      </div>


      <Container fluid>
        <div className="container-fluid d-flex justify-content-between">
          <h6 className="heading-6">Pending Bank Transfer </h6>
        </div>
        <Row>
          <Col lg="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header >
                <Card.Title as="h4">
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      className="mx-2"
                      aria-label="Search"
                      value={globalFilter || ''} onChange={(e) => setGlobalFilter(e.target.value)}
                    />
                  </Form>

                </Card.Title>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table className="table-hover table-striped " {...getTableProps()} >

                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                            {column.render("Header")}
                            {/* Add a sort direction indicator */}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? " 🔽"
                                  : " 🔼"
                                : ""}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr  {...row.getRowProps()}>
                          {/* {console.log(row.original.id)} */}
                          {row.cells.map((cell) => {
                            //  const { column } = cell.value;
                            //  let Id = column.Name;
                            //  console.log(cell.value);

                            return (<td  {...cell.getCellProps()}> {cell.render("Cell")}</td>)

                          })}
                        </tr>
                      );
                    }

                    )}
                  </tbody>

                </Table>
              </Card.Body>

              <PaginationSection
                pageIndex={pageIndex}
                pageCount={pageOptions.length}
                canPreviousPage={canPreviousPage}
                canNextPage={canNextPage}
                gotoPage={gotoPage}
                previousPage={previousPage}
                nextPage={nextPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                pageOptions={pageOptions}
              />
            </Card>

          </Col>
        </Row>
      </Container>
    </>
  )
};

export default PendingBankStatus;